module.exports = __webpack_public_path__ + "assets/adpoly-facility-security-cameras-bulk-upload-template.cddf8f23.xlsx";